import styled from 'styled-components';


export  const Container = styled.div`

    width: 100%;
    min-width: 600px;



    display:flex;
    flex-direction: column;





    section{
        display: flex;

        height: calc(100% - 150px);
        width: 100%;




    }

`;